import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<any> {

  canDeactivate(component: any) {
    return component.canDeactivate();
  }

}
